













































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import BaseView from "@/components/BaseView.vue";
import { BATCH_STATES, BatchResource } from "@/store/batch/types";
import { Pagination } from "@/store";
import { DataOptions } from "vuetify";

@Component({
  components: {
    BaseView
  }
})
export default class BatchList extends Vue {
  //
  readonly store = this.$store.direct;
  readonly title = "Cargas";
  readonly subtitle = "Lista todas las cargas hechas previamente";
  readonly info = null;
  // Component properties
  loading: boolean = false;

  get options() {
    return this.store.getters.options;
  }

  set options(val: DataOptions) {
    this.store.commit.SET_PAGINATION_FROM_DATA_OPTIONS(val);
  }

  get pagination() {
    return this.store.state.pagination;
  }

  get totalItems() {
    return this.store.state.totalItems;
  }

  get open1() {
    return this.selected.remove != "";
  }

  set open1(val: boolean) {
    if (!val) this.selected.remove = "";
  }

  openRemove(val: string) {
    this.selected.remove = val;
  }

  get open2() {
    return this.selected.confirm !== undefined;
  }

  set open2(val: boolean) {
    if (!val) this.selected.confirm = undefined;
  }

  openConfirm(val: BatchResource) {
    this.selected.confirm = val;
  }

  selected: { confirm?: BatchResource; remove: string } = {
    confirm: undefined,
    remove: ""
  };

  headers = [
    {
      text: "#",
      align: "left",
      sortable: false
    },
    {
      text: "Nombre",
      value: "name",
      align: "center"
    },
    {
      text: "Descripción",
      value: "description",
      align: "center"
    },
    {
      text: "Estado",
      value: "state",
      align: "center"
    },
    {
      text: "Acciones",
      align: "center",
      sortable: false
    }
  ];

  get batches() {
    return this.store.getters.batch.batches;
  }

  getType(state: string) {
    let type = BATCH_STATES.find(t => {
      return t.value == state;
    });
    return type ? type.label : state;
  }

  getColor(state: string) {
    let type = BATCH_STATES.find(t => {
      return t.value == state;
    });
    return type ? type.color : "";
  }

  async confirm(batch: BatchResource) {
    let res = await this.store.dispatch.batch.confirm(batch);
    if (res.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "Ha ocurrido un error. Intente nuevamente.",
        type: "error"
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "La carga ha sido confirmada correctamente.",
        type: "success"
      });
    }
    this.open2 = false;
  }

  async destroy(id: string) {
    let res = await this.store.dispatch.batch.delete(id);
    if (res.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "Ha ocurrido un error. Intente nuevamente.",
        type: "error"
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "La carga se ha eliminado correctamente.",
        type: "success"
      });
    }
    this.open1 = false;
  }

  refresh() {
    this.store.dispatch.batch.get();
  }

  mounted() {
    this.refresh();
  }

  @Watch("pagination", { deep: true })
  handleOptionsChange(newVal: Pagination, oldVal: Pagination) {
    if (
      this.store.state.totalItems != undefined &&
      (newVal.page != oldVal.page ||
        newVal.itemsPerPage != oldVal.itemsPerPage ||
        newVal.sortBy != oldVal.sortBy ||
        newVal.sortDesc != oldVal.sortDesc)
    ) {
      this.store.dispatch.batch.get();
    }
  }
}
